import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Input, Inject, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhAlgorithm, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { ChooseIconComponent, ChooseImageComponent, EditNameComponent, FunctionService, LanguageService, ManageLibraryComponent } from 'vhobjects-service';

@Component({
  selector: 'atw-content-preview-slider-admin',
  templateUrl: './content-preview-slider-admin.component.html',
  styleUrls: ['./content-preview-slider-admin.component.scss'],
})
export class AtwContentPreviewSliderAdmin implements OnInit {
  @Input() data: any;
  @Input() type: any;

  loading = false;
  subproject: any;
  id_subproject: string = '';
  blocks_of_page?: any = [];
  itemEdit: any;
  itemEditType: string;
  isShowUploadToServer = false;
  compressType = 'compress-frame'
  isSharedImg = { 'image': true, 'logo': true };
  compressWidth = 100;
  compressHeight = 100;
  uploadToServerLoading = false;
  pageSize = 10;
  pageIndex = 1;
  total = 1;
  arr_link_page: any;
  sources = [
    { label: 'tai_anh_len', value: 'device' },
    { label: 'thu_vien', value: 'library' },
    { label: 'kho_anh_dung_chung', value: 'free_img' },
    { label: 'duong_dan_hinh_anh', value: 'url' },
  ]
  clickActionOptions:any = [
    { value: true, label: 'cuon_len_dau_trang' },
    { value: false, label: 'giu_nguyen_vi_tri' },
    { value: 'scroll_to_block', label: 'cuon_den_khoi' }
  ]
  source = 'device';
  type_link: any = [
    { value: 'none', label: 'khong' },
    { value: 'page_link', label: 'den_trang' },
    { value: 'navigation_link', label: 'lien_ket_dieu_huong' },
    { value: 'hyper_link', label: 'lien_ket_trang_khac' },
    { value: 'mailto', label: 'Email' }, 
    { value: 'tel', label: 'so_dien_thoai' }
  ];
  mapType:any = {
    'text': 'value',
    'button': 'button',
  }
  isOpenModal = false;
  /** Dùng cho hình ảnh cần nén cho các thiết bị khác nhau tối ưu SEO */
  deviceTemp: 'desktop' | 'tablet_landscape' | 'tablet_portrait' | 'mobile_landscape' | 'mobile_portrait' = 'desktop';
  /** Kích thước hình ảnh có phù hợp với kích thước thực tế hay chưa? */
  isDesignImageSizeValid: boolean = true;
  /** Chứa các kích thước thiết kế vật thể image của các thiết bị */
  imageSizeOfDevices: any = {};

  listOfData: any[] = [];
  dataRow: any;
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    public functionService: FunctionService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhAlgorithm: VhAlgorithm,
    private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private vhImage: VhImage,
    private matDialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    this.getData();
  }

  getBlocksbyPage() {
    if (
      this.itemEdit.type_link == 'page_link' ||
      this.itemEdit.type_link == 'navigation_link'
    ) {
      const link = this.itemEdit.link.replace(/^\/+/, '').split('/')[0];
      this.vhQueryAutoWeb
        .getPages_byFields({ link: { $eq: link } })
        .then((pages: any) => {
          if (pages.length > 0) {
            this.vhQueryAutoWeb
              .getBlocks_byIDpage(pages[0]._id)
              .then((res: any) => {
                this.blocks_of_page = res;
              });
          }
        });
    }
  }

  deleteRow(id: string): void {
    this.data.staticdata.datas = this.data.staticdata.datas.filter(
      (d) => d._id !== id
    );

    this.vhQueryAutoWeb
      .updateObject(this.data._id, {
        staticdata: this.data.staticdata,
      })
      .then((bool: any) => {
        this.listOfData = this.listOfData.filter((d) => d._id !== id);
        if (this.functionService.getTypeConfig() == 'admin')
          this.functionService.createMessage(
            'success',
            'cap_nhat_du_lieu_thanh_cong'
          );
      });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      if (changes?.data) {
        this.getData();
      }

      // if (this.itemEditType == 'image' && this.isOpenModal) {
      //   this.isDesignImageSizeValid = await this.checkDesignImageSize();
      // }
    }
  }

  handleAddData() {
    // Kiểm tra cờ loading để ngăn người dùng click nhiều lần liên tiếp khi đang xử lý
    if (this.loading) return;
    this.loading = true;

    if (!this.listOfData) {
      this.loading = false;
      return;
    }

    const itemAdd = {
      sort: 1,
      _id: (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1),
      logo: {
        desktop_src: "https://domain02.webappgiare.vn/assets/viethas.png",
        tablet_landscape_src: "https://domain02.webappgiare.vn/assets/viethas.png",
        tablet_portrait_src: "https://domain02.webappgiare.vn/assets/viethas.png",
        mobile_landscape_src: "https://domain02.webappgiare.vn/assets/viethas.png",
        mobile_portrait_src: "https://domain02.webappgiare.vn/assets/viethas.png",
        link: "",
        type_link: "none",
        hyper_link: "",
        is_scroll: true,
        scroll_block_id: ""
      },
      title: {
        content: "Tiêu đề",
        content_vn: "Tiêu đề",
        link: "",
        type_link: "none",
        hyper_link: "",
        is_scroll: true,
        scroll_block_id: ""
      },
      desc: {
        content: "Mô tả",
        content_vn: "Mô tả",
        link: "",
        type_link: "none",
        hyper_link: "",
        is_scroll: true,
        scroll_block_id: ""
      },
      image: {
        desktop_src: "https://xuongthietkecuakas.com/wp-content/uploads/2023/12/THIET-KE-NHA-PHO-min.jpg.webp",
        tablet_landscape_src: "https://xuongthietkecuakas.com/wp-content/uploads/2023/12/THIET-KE-NHA-PHO-min.jpg.webp",
        tablet_portrait_src: "https://xuongthietkecuakas.com/wp-content/uploads/2023/12/THIET-KE-NHA-PHO-min.jpg.webp",
        mobile_landscape_src: "https://xuongthietkecuakas.com/wp-content/uploads/2023/12/THIET-KE-NHA-PHO-min.jpg.webp",
        mobile_portrait_src: "https://xuongthietkecuakas.com/wp-content/uploads/2023/12/THIET-KE-NHA-PHO-min.jpg.webp"
      },
      button: {
        content: "Nút điều hướng",
        content_vn: "Nút điều hướng",
        link: "",
        type_link: "none",
        hyper_link: "",
        is_scroll: true,
        scroll_block_id: ""
      }
    };

    // TRƯỜNG HỢP 1: Đã có dữ liệu trong danh sách (Thêm dòng tiếp theo)
    if (this.listOfData.length > 0) {
      const sortLast = this.listOfData[this.listOfData.length - 1].sort + 1;
      itemAdd.sort = sortLast
    }
    // TRƯỜNG HỢP 2: Chưa có dữ liệu nào (Tạo dòng đầu tiên)
    else {
      // Khởi tạo mảng datas nếu chưa có và thêm item mới vào
      this.data.staticdata.datas = this.data.staticdata.datas || [];
    }

    // Cập nhật danh sách datas trong staticdata
    this.data.staticdata.datas = [
      ...this.data.staticdata.datas,
      itemAdd,
    ];

    // Gọi API cập nhật đối tượng vào cơ sở dữ liệu
    this.vhQueryAutoWeb
      .updateObject(this.data._id, {
        staticdata: this.data.staticdata,
      })
      .then((res) => {
        // Xử lý hiển thị: clone item và convert data object sang array để render
        let newData = { ...itemAdd };
        // Cập nhật danh sách hiển thị trên UI
        this.listOfData = [...this.listOfData, newData];

        // Hiển thị thông báo thành công nếu đang ở trang admin
        if (this.functionService.getTypeConfig() == 'admin')
          this.functionService.createMessage(
            'success',
            'cap_nhat_du_lieu_thanh_cong'
          );

        // Tắt cờ loading
        this.loading = false;
      });
  }

  getData() {
    if ((this.loading = false)) return;
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(
      this.id_subproject
    );
    if (this.subproject?.style == 'app') {
      this.deviceTemp = 'tablet_portrait';
    }
    this.loading = true;
    if (typeof this.data.staticdata.datas != 'object') {
      this.data.staticdata.datas = [];
    }
    this.listOfData = this.data.staticdata.datas || [];

    this.vhAlgorithm.sortNumberbyASC(this.listOfData, 'sort');
    this.loading = false;
    this.getLinkAllPages();
  }

  updateOrdinal(dataRow) {
    this.data.staticdata.datas = this.data.staticdata.datas.map(
      (item) =>
        item._id === dataRow._id
          ? { ...item, sort: Number(dataRow.sort) }
          : item
    );

    this.vhQueryAutoWeb
      .updateObject(this.data._id, {
        staticdata: this.data.staticdata,
      })
      .then((res) => {
        if (res)
          this.functionService.createMessage(
            'success',
            'cap_nhat_du_lieu_thanh_cong'
          );
      });
  }

  updateData(dataRow) {
    this.data.staticdata.datas = this.data.staticdata.datas.map(
      (item) =>
        item._id === dataRow._id
          ? {
              ...item,
              [this.itemEditType]: {
                ...item[this.itemEditType],
                ...this.itemEdit
              }
            }
          : item
    );

    this.vhQueryAutoWeb
      .updateObject(this.data._id, {
        staticdata: this.data.staticdata,
      })
      .then((res) => {
        if (this.functionService.getTypeConfig() == 'admin')
          this.functionService.createMessage(
            'success',
            'cap_nhat_du_lieu_thanh_cong'
          );
      });
  }

  onUpload(e, dataRow) {
    const file = e.target.files[0];

    if (file) {
      let compressType = this.compressType;
      let resolution = {};

      if (compressType == 'compress-frame') {
        // resolution = this.imageSizeOfDevices[this.deviceTemp];
        const mapType = {
          image: { width: 800, height: 500 },
          logo: { width: 40, height: 40 }
        }
        resolution = mapType[this.itemEditType];
      } else if (compressType == 'custom') {
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight,
        };
        compressType = 'compress-frame';
      }
      this.vhImage
        .getImageFromDesktop_Autoweb(file, 'images/design/objects', {
          compress_type: compressType,
          resolution: resolution,
        })
        .then(
          (rsp: any) => {
            console.log('rsp', rsp);
            if (rsp.vcode === 0) {
              if (this.isSharedImg[this.itemEditType]) {
                this.itemEdit.value = rsp.data;
                this.functionService.devices.map((d) => {
                  this.itemEdit[`${d.value}_src`] = rsp.data;
                });
              } else {
                this.itemEdit[this.deviceTemp + '_src'] = rsp.data;
                // Này để khởi tạo giá trị ban đầu
                if (this.deviceTemp == 'desktop') {
                  this.itemEdit.value = rsp.data;
                }
              }
              this.updateData(dataRow);
            } else {
              this.functionService.createMessage(
                'error',
                `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${
                  rsp.msg
                }`
              );
            }
          },
          (error) => {
            console.error(error);
          }
        )
        .catch((error) => {
          console.error(error);
        });
    }
  }

  path = ''; // Nên để rỗng vì ban đâu sẽ đi vào thư mục /images/design/objects
  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary(dataRow) {
    const dialogRef = this.matDialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path || '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        if (this.isSharedImg[this.itemEdit]) {
          this.itemEdit.value = data.href;
          this.functionService.devices.map((d) => {
            this.itemEdit[`${d.value}_src`] = data.href;
          });
        } else {
          this.itemEdit[this.deviceTemp + '_src'] = data.href;
          // Này để khởi tạo giá trị ban đầu
          if (this.deviceTemp == 'desktop') {
            this.itemEdit.value = data.href;
          }
        }
        this.updateData(dataRow);
      }
      this.path = data.path;
    });
  }

  openFreeImage(dataRow) {
    const dialogRef = this.matDialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.isSharedImg[this.itemEdit]) {
          this.itemEdit.value = result;
          this.functionService.devices.map((d) => {
            this.itemEdit[`${d.value}_src`] = result;
          });
        } else {
          this.itemEdit[this.deviceTemp + '_src'] = result;
          // Này để khởi tạo giá trị ban đầu
          if (this.deviceTemp == 'desktop') {
            this.itemEdit.value = result;
          }
        }
        this.updateData(dataRow);
      }
    });
  }

  async chooseItemEdit(
    obj: 'title' | 'desc' | 'button' | 'logo' | 'image', dataRow
  ): Promise<void> {
    this.dataRow = dataRow;
    this.itemEditType = obj;
    this.itemEdit = dataRow[obj];
    this.itemEdit.scroll_distance = this.itemEdit.scroll_distance || 0;
    this.isOpenModal = true;

    if (obj == 'image') {
      // Lấy ra kích thước thiết kế để dùng cho các hàm
      // this.getDesignDimensionsOfDevices(this.itemEdit);

      // Khởi tạo device + value nếu chưa có
      this.functionService.devices.forEach((d) => {
        this.itemEdit[`${d.value}_src`] ??=
          'assets/patterns/ImageComponent/green-tree.png';
      });

      // Kiểm tra nút cập nhật size ảnh theo size thiết kế có cần hiển thị hay không
      // this.isDesignImageSizeValid = await this.checkDesignImageSize();
    }

    this.getBlocksbyPage();
  }

  openUploadToServer() {
    this.isShowUploadToServer = true;
  }

  /**
   * Xử lý lấy link các page về.
   */
  getLinkAllPages() {
    this.vhQueryAutoWeb
      .getPages_byFields({ type: { $in: ['blank', 'homepage'] } })
      .then((pages: any) => {
        this.arr_link_page = pages.map((page) => {
          // if (!page.name) console.warn('Không có name', page)
          if (
            !page['name_' + this.functionService.selectedLanguageCode] &&
            page.name
          ) {
            return {
              ...page,
              ['name_' + this.functionService.selectedLanguageCode]: page.name,
            };
          } else return page;
        });
        this.arr_link_page = this.vhAlgorithm.sortVietnamesebyASC(
          this.arr_link_page,
          'name_' + this.functionService.selectedLanguageCode
        );
        // this.arr_link_page = pages;
      });
  }

  // remove link khi click vào nút x
  removeLink(fieldName: string) {
    this.itemEdit[fieldName] = '';
  }

  /**
   * Update dữ liệu của data
   */
  updateObject() {
    if (this.functionService.getTypeConfig() == 'admin') {
      if (!this.data.hasOwnProperty('fieldUpdate'))
        this.data['fieldUpdate'] = [];
      if (!this.data['fieldUpdate'].includes('name'))
        this.data['fieldUpdate'].push('name');
      return;
    }
    this.vhQueryAutoWeb
      .updateObject(this.data._id, { name: this.data.name })
      .then(
        (bool) => {
          // console.log('bool', bool);
        },
        (error) => {
          console.log('error', error);
          this.functionService.createMessage(
            'error',
            'Cập nhật dữ liệu thất bại !!!'
          );
        }
      );
  }

  cancelUploadToServer() {
    this.isShowUploadToServer = false;
  }

  okUploadToServer(itemEdit) {
    this.uploadToServerLoading = true;
    let compressType = this.compressType;
    let resolution = {};

    if (compressType == 'compress-frame') {
      // resolution = this.imageSizeOfDevices[this.deviceTemp];
      const mapType = {
        image: { width: 800, height: 500 },
        logo: { width: 40, height: 40 }
      }
      resolution = mapType[this.itemEditType];
    } else if (compressType == 'custom') {
      resolution = {
        width: +this.compressWidth,
        height: +this.compressHeight,
      };
      compressType = 'compress-frame';
    }

    this.vhImage
      .getImageFromURL_Autoweb(
        itemEdit[`${this.deviceTemp}_src`],
        'images/design/objects',
        {
          compress_type: compressType,
          resolution: resolution,
        }
      )
      .then((res: any) => {
        if (res.vcode != 0) {
          console.error(res.msg);
          this.functionService.createMessage('error', res.msg, 5000);
          this.isShowUploadToServer = false;
          return;
        }

        if (this.isSharedImg[this.itemEdit]) {
          this.functionService.devices.map((d) => {
            itemEdit[`${d.value}_src`] = res.data;
          });
        } else {
          itemEdit[this.deviceTemp + '_src'] = res.data;
          // Này để khởi tạo giá trị ban đầu
          if (this.deviceTemp == 'desktop') {
            itemEdit.value = res.data;
          }
        }
        this.updateData(this.dataRow);
        this.isShowUploadToServer = false;
      })
      .catch((error) => {
        console.error(error);
        if (error.message && error.message.includes('413')) {
          // Thông báo cho người dùng
          this.functionService.createMessage(
            'error',
            'file_anh_qua_lon_vui_chon_file_anh_co_dung_luong_nho_hon_1mb'
          );
        }
      })
      .finally(() => (this.uploadToServerLoading = false));
  }

  openDialogChooseIcon() {
    const dialogRef = this.matDialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.itemEdit.icon_name = result.icon;
        this.updateData(this.dataRow);
      }
    });
  }

  onDateTimeChange(result, item): void {
    this.itemEdit = item;
    if (result instanceof Date && !isNaN(result.getTime())) {
      item.value = result;
      this.itemEdit.value = result.toISOString();
    } else {
      item.value = new Date('2025-05-19 14:30:00');
    }
  }

  onDateTimeOk(result, dataRow) {
    this.updateData(dataRow);
  }

  /**
   * Hàm kiểm tra giá trị truyền vào
   * @param { mailto, tel }
   * @returns boolean
   */
  isValidValue({
    mailto,
    tel,
  }: { mailto?: string; tel?: string } = {}): boolean {
    const patterns: any = {
      // mailto: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      mailto:
        /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*$/i,
      // tel: /^((0|\+84)(3[2-9]|5[2689]|7[06-9]|8[1-689]|9[0-46-9])[0-9]{7}|(1800|1900)[0-9]{4})$/,
    };

    if (mailto) return patterns.mailto.test(mailto);
    // if (tel) return patterns.tel.test(tel);
    if (tel) return true;

    return true;
  }

  /**
   * Hàm lấy kích thước thiết kế của hình ảnh trong khung lưới
   * @param item
   */
  // private getDesignDimensionsOfDevices(item) {
  //   const idObj = item.id_ordinal.split('_')[0];
  //   const obj = this.data.objects.find((object) => object._id === idObj);
  //   this.functionService.devices.forEach((d) => {
  //     this.imageSizeOfDevices[d.value] = {}; // Reset giá trị cũ

  //     // Trường hợp dimension đã có dữ liệu
  //     if (
  //       obj?.[`${d.value}_config`]?.dimension?.width &&
  //       obj?.[`${d.value}_config`]?.dimension?.height
  //     ) {
  //       this.imageSizeOfDevices[d.value] = obj[`${d.value}_config`].dimension;
  //     }
  //     // Trường hợp type là image
  //     // Và chưa có dimension thì dùng của class image
  //     else if (
  //       item.type == 'image' &&
  //       obj[`${d.value}_class`]?.image?.width &&
  //       obj[`${d.value}_class`]?.image?.height
  //     ) {
  //       const container = obj[`${d.value}_class`].image;
  //       this.imageSizeOfDevices[d.value] = {
  //         width: parseFloat(container.width),
  //         height: parseFloat(container.height),
  //       };
  //     }
  //   });
  // }

  /**
   * Lấy ra tên file và đuôi file
   * @param url Đường dẫn ảnh
   * @example const { fileName, fileExtension } = getFileInfo("https://115.78.228.208:20350/autowebapp/67c1b593b1344364462b082b/images/design/objects/3-1-768x768%20(3).png");
   */
  getFileInfo(url: string) {
    const decodedUrl = decodeURIComponent(url);
    const parts = decodedUrl.split('/');

    // Lấy tên file (phần cuối)
    const fullFileName = parts.pop() || '';
    const dotIndex = fullFileName.lastIndexOf('.');

    // Tìm và lấy phần giữa (ví dụ: "images/design/objects")
    const indexImages = parts.indexOf('images');
    const folderPath =
      indexImages !== -1 ? parts.slice(indexImages).join('/') : '';

    return {
      fullFileName, // ví dụ: "3-1-768x768 (3).png"
      fileName: fullFileName.substring(0, dotIndex), // "3-1-768x768 (3)"
      fileExtension: fullFileName.substring(dotIndex + 1), // "png"
      folderPath, // "images/design/objects"
    };
  }

  /** Hàm kiểm tra có cần phải hiển thị nút cập nhật không */
  private async checkDesignImageSize() {
    // chạy song song cho nhanh
    const results = await Promise.all(
      this.functionService.devices.map(async (d) => {
        // Trường hợp itemEdit device value chưa có thì gán tạm
        this.itemEdit[`${d.value}_src`] ??= this.itemEdit.value;

        // Nếu giao diện thiết kế đã ẩn thiết bị thì không cần check
        if (!this.subproject?.[`${d.value}_template_display`]) {
          return false;
        }
        // Ảnh gốc
        const url = this.itemEdit[`${d.value}_src`];
        const imgSize = await this.functionService.getImageSize(url);
        // Container thiết kế
        const containerSize = this.imageSizeOfDevices[d.value];

        return this.functionService.checkRatioDesignImgSize(
          imgSize,
          containerSize
        );
      })
    );

    // chỉ cần 1 device trả về true → return true
    return results.some((v) => v === true);
  }

  /**
   * Hàm update kích thước ảnh phù hợp cho từng kích thước thiết kế của từng thiết bị
   * @param itemEdit
   * @param dataRow
   */
  async updateDesignImageSize(itemEdit, dataRow) {
    const messages: {
      type: 'success' | 'warning' | 'error';
      msg: string;
      duration?: number;
    }[] = [];

    // ⭐ Show Loading 1 lần duy nhất
    await this.functionService.showLoading(
      '',
      'current-loading',
      null,
      0,
      false
    );

    await Promise.all(
      this.functionService.devices.map(async (d) => {
        // Trường hợp itemEdit device value chưa có thì gán tạm
        this.itemEdit[`${d}_src`] ??= this.itemEdit.value;

        // Nếu giao diện thiết kế đã ẩn thiết bị thì không cần check
        if (!this.subproject[`${d.value}_template_display`]) return;

        /** Khai báo tin nhắn thông báo cho từng thiết bị */
        const msgDevices = `(${this.languageService.translate(
          'thiet_bi'
        )} ${this.languageService.translate(d.label)}): `;

        // Ảnh gốc
        const url = itemEdit[`${d.value}_src`];

        // Trường hợp đường dẫn không có hoặc rỗng
        if (!url) {
          messages.push({
            type: 'warning',
            msg:
              msgDevices +
              this.languageService.translate('chua_truyen_duong_dan_anh'),
          });
          return;
        }

        // Trường hợp chưa up lên server đây là bước bắt buộc
        // vì cần phải giữ một ảnh gốc để sau này có resize ảnh thì còn cần ảnh gốc để nén lại
        if (!url.includes(this.id_subproject)) {
          messages.push({
            type: 'warning',
            msg:
              msgDevices +
              this.languageService.translate('anh_nay_chua_chuyen_len_server'),
          });
          return;
        }

        const imgSize = await this.functionService.getImageSize(url);

        // Container thiết kế
        const containerSize = this.imageSizeOfDevices[d.value];

        // Trường hợp nếu ảnh này đã phù hợp thì trả về thông báo chứ không update nữa
        if (
          !this.functionService.checkRatioDesignImgSize(imgSize, containerSize)
        ) {
          messages.push({
            type: 'warning',
            msg:
              msgDevices +
              this.languageService.translate(
                'anh_nay_da_phu_hop_khong_can_cap_nhat_nua'
              ),
          });
          return;
        }

        const msgSolution =
          this.functionService.getTypeConfig() == 'admin'
            ? 'vui_long_chuan_bi_mot_hinh_khac_phu_hop'
            : 'vui_long_sua_thiet_ke_hoac_chuan_bi_mot_hinh_khac_phu_hop';

        // Trường hợp đã cập nhật hoặc width là bằng sẵn rồi nhưng height thiết kế không phù hợp
        // Thì trả về thông báo chứ không cho update nữa vì gây tăng dung lượng lưu ảnh không cần thiết
        if (
          imgSize.width == containerSize.width &&
          imgSize.height != containerSize.height
        ) {
          const mTmp =
            containerSize.height > imgSize.height
              ? 'chieu_cao_thiet_ke_lon_hon_chieu_cao_anh'
              : 'chieu_cao_thiet_ke_nho_hon_chieu_cao_anh';
          const m =
            this.languageService.translate(mTmp) +
            '. ' +
            this.languageService.translate(msgSolution);
          messages.push({
            type: 'error',
            msg: msgDevices + m + '!!!',
            duration: 8000,
          });
          return;
        }

        // Trường hợp nếu ảnh này bé hơn kích thước thiết kế thì báo cho người dùng và không cập nhật
        if (imgSize.width < containerSize.width) {
          const mTmp =
            'chieu_dai_anh_nho_hon_chieu_dai_thiet_ke_lam_cho_viec_nen_anh_theo_khung_hien_thi_hinh_anh_khong_hoat_dong';
          const m =
            this.languageService.translate(mTmp) +
            '. ' +
            this.languageService.translate(msgSolution);
          messages.push({
            type: 'error',
            msg: msgDevices + m + '!!!',
            duration: 8000,
          });
          return;
        }

        // Cập nhật ảnh cho từng thiết bị
        try {
          const rsp: any = await this.vhImage.getImageFromURL_Autoweb(
            url,
            'images/design/objects',
            {
              compress_type: 'compress-frame',
              resolution: containerSize,
            }
          );

          if (rsp.vcode == 0) {
            itemEdit[`${d.value}_src`] = rsp.data;
            if (d.value == 'desktop') {
              itemEdit.value = rsp.data;
            }

            messages.push({
              type: 'success',
              msg:
                msgDevices +
                this.languageService.translate('tai_anh_thanh_cong'),
            });
          } else {
            messages.push({
              type: 'error',
              msg:
                msgDevices +
                this.languageService.translate('tai_anh_that_bai_ly_do') +
                rsp.msg,
            });
          }
        } catch (error: any) {
          if (error.message?.includes('413')) {
            messages.push({
              type: 'error',
              msg:
                msgDevices +
                this.languageService.translate(
                  'file_anh_qua_lon_vui_chon_file_anh_co_dung_luong_nho_hon_1mb'
                ),
            });
          }
        }
      })
    );

    // CHỈ CHẠY SAU KHI HOÀN TẤT TẤT CẢ DEVICE
    this.updateData(dataRow);

    // ⭐ Hide loading (delay 200ms để tránh flick)
    await this.functionService.hideLoading(200);

    // Show toàn bộ message sau cùng
    messages.forEach((m) => {
      this.functionService.createMessage(m.type, m.msg, m.duration ?? 5000);
    });
  }

  /**
   * Sao chép đường dẫn hình ảnh vào bộ nhớ tạm
   */
  copyLinkImg(text?: string) {
    if (isPlatformBrowser(this.platformId)) {
      const textCopy = text || this.itemEdit[this.deviceTemp + '_src'];
      navigator.clipboard
        .writeText(textCopy)
        .then(() => {
          this.functionService.createMessage(
            'success',
            'da_sao_chep_vao_bo_nho_tam',
            2000
          );
        })
        .catch((err) => {
          this.functionService.createMessage('error', 'loi_khi_sao_chep', 2000);
          console.error('❌ Lỗi khi copy:', err);
        });
    }
  }

  handleLinkImg(dataRow) {
    if (this.isSharedImg[this.itemEdit]) {
      this.functionService.devices.map((d) => {
        this.itemEdit[`${d.value}_src`] = this.itemEdit.value;
      });
    } else {
      this.itemEdit[this.deviceTemp + '_src'] = this.itemEdit.value;
    }
    this.updateData(dataRow);
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(dataRow, fieldContent) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        this.itemEdit[`${fieldContent}_${this.functionService.languageTempCode}`],
        { isAdmin: true }
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            if (
              this.functionService.languageTempCode != lang.code 
              && !this.itemEdit[`${fieldContent}_${lang.code}`]
            ) {
              this.itemEdit[`${fieldContent}_${lang.code}`] = data.find(
                item => item.langCode == lang.code
              ).translatedText;
            }
          });
          this.updateData(dataRow);
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateData(dataRow);
    }
  }
}
